// volto-yizhou — tenant addon for yizhou.ljusa-tider.se, the YiZhou Laser
// EU market-access + authorised-representative working site (DR-2026-266).
//
// Deliberately minimal at v0.1.0: two supported languages (en canonical +
// zh-CN for YiZhou HQ, Victoria-reviewed) over the converged VLT-8 baseline.
// Swedish and market languages are added when authority- or buyer-facing
// content demands them. Private-by-default (content stays in the private
// workflow state — the REFL-REG-001 working surface), so the login-state
// indicator is load-bearing: the token-truth UserTools over VLT's Anontools
// (BUG-2026-217 / BUG-2026-211 / CR-2026-009 pattern — VLT's Anontools
// renders from a session-derived cache that goes stale on all-private
// tenants) ships via the fleet baseline addon below.

import { applyTenantBaseline } from 'volto-tenant-baseline/applyTenantBaseline';
import YizhouColophon from './components/YizhouColophon';

const NullSlot = () => null;

const applyConfig = (config) => {
  config.settings.supportedLanguages = ['en', 'zh-CN'];
  config.settings.defaultLanguage = 'en';
  config.settings.isMultilingual = true;

  // Footer: brand-only colophon over VLT's default (DR-2026-248 slot
  // pattern; the Plone-CMS credit misstates the stack — this fleet runs
  // Nick, operator s527). The AR identity line (REF-YIZHOU-001 Part D §5.1)
  // + the zh brand name land with the steven-review round.
  config.registerSlotComponent({ slot: 'preFooter', name: 'footerLogos', component: NullSlot });
  config.registerSlotComponent({ slot: 'postFooter', name: 'PostFooterFollowUsLogoAndLinks', component: NullSlot });
  config.registerSlotComponent({ slot: 'postFooter', name: 'Colophon', component: YizhouColophon });

  // -- Fleet baseline (DR-2026-272 / CR-2026-077) --
  // UserTools slot registration (token-truth over VLT's Anontools) +
  // GuidesLink + tenantBaseline settings — all versioned once in
  // volto-tenant-baseline. Must be called HERE (outermost addon, runs after
  // VLT) so the slot registration wins; the addon's LanguageSelector shadow
  // and 880px token apply via addons[] membership. tenantKey makes the
  // Guides entry carry ?from=yizhou so the commons-side ReturnLink can
  // offer the way back (DR-2026-272 return-navigation wave; the AIV-2026-062
  // reconciliation — this replaces the retracted DR-2026-303 v0.1.0
  // colophon link).
  config = applyTenantBaseline(config, { tenantKey: 'yizhou' });

  return config;
};

export default applyConfig;
